import { TableCell, TableSortLabel } from '@mui/material';
import type { Sort, SortOrder } from 'app/common/types';
import cx from 'classnames';
import type React from 'react';
import { useCallback } from 'react';
import type { TableHeadComponent } from '../types.js';

function toggleSortOrder(dir: SortOrder): SortOrder {
  if (dir === 'asc') {
    return 'desc';
  }

  return 'asc';
}

export function headerCellFactory(customClassName?: string): React.FC<TableHeadComponent> {
  const headerClassName = cx(customClassName);

  const HeaderCell: React.FC<TableHeadComponent> = (props: TableHeadComponent) => {
    const { title, name, sort, updateSort } = props;
    const active = sort && name === sort.field;
    const handleClick = useCallback(() => {
      if (updateSort) {
        const newSort: Sort = {
          field: name,
          order: sort && active ? toggleSortOrder(sort.order) : 'desc'
        };
        updateSort(newSort);
      }
    }, [name, active, sort, updateSort]);
    const contents = updateSort ? (
      <TableSortLabel active={active} direction={sort?.order}>
        {title}
      </TableSortLabel>
    ) : (
      title
    );
    return (
      <TableCell className={headerClassName} onClick={handleClick} title={title}>
        {contents}
      </TableCell>
    );
  };

  return HeaderCell;
}

export default headerCellFactory();
